// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61869ebe","453":"2e29ba2c","667":"389f6da9"}[chunkId] + ".chunk.js";
};